var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "content" }, [
          _c(
            "div",
            { staticClass: "home" },
            [
              _c("router-link", { attrs: { to: "/" } }, [
                _c("span", { staticClass: "icon-home" }),
                _vm._v(" "),
                _c("span", [_vm._v("返回首页")])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "user" }, [
            _c("div", { staticClass: "user-avatar" }, [
              _c("img", {
                staticStyle: { height: "100%", "border-radius": "50%" },
                attrs: { src: _vm.userInfo.headImage, alt: "" }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "user-name" }, [
              _c("span", [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.userInfo.account
                        ? _vm.userInfo.account
                        : _vm.userInfo.name
                    ) +
                    "\n          "
                )
              ]),
              _vm._v(" "),
              _c("span", [_vm._v("商家工作台")])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "main" }, [
        _vm.isShowImage
          ? _c("img", {
              staticClass: "img2560",
              attrs: {
                src: require("../../assets/images/ruzhuBanner.png"),
                alt: ""
              }
            })
          : _c("img", {
              staticClass: "img1920",
              attrs: {
                src: require("../../assets/images/ruzhuBanner.png"),
                alt: ""
              }
            }),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "tabs" }, [
          _c(
            "div",
            {
              class: _vm.active ? "active" : "",
              on: {
                click: function($event) {
                  _vm.active = true
                }
              }
            },
            [_vm._v("\n        一键开店\n      ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              class: _vm.active ? "" : "active",
              on: {
                click: function($event) {
                  _vm.active = false
                }
              }
            },
            [_vm._v("\n        常见问题\n      ")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "btns" }, [
          _c(
            "div",
            {
              staticClass: "btn",
              staticStyle: { "margin-right": "30px" },
              on: { click: _vm.rigster }
            },
            [
              _c("div", { staticClass: "text1" }, [_vm._v("1")]),
              _vm._v(" "),
              _c("div", { staticClass: "text2" }, [_vm._v("供应商注册")]),
              _vm._v(" "),
              _c("div", { staticClass: "text3" }, [_vm._v("去注册>")])
            ]
          ),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "btn",
              staticStyle: { "margin-left": "30px" },
              on: { click: _vm.renzheng }
            },
            [
              _c("div", { staticClass: "text1" }, [_vm._v("2")]),
              _vm._v(" "),
              _c("div", { staticClass: "text2" }, [_vm._v("供应商认证")]),
              _vm._v(" "),
              _c("div", { staticClass: "text3" }, [_vm._v("去认证>")])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.active
        ? _c("div", [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])
        : _c("div", [
            _vm._m(5),
            _vm._v(" "),
            _c("div", { staticClass: "hot" }, [
              _vm._m(6),
              _vm._v(" "),
              _c("div", { staticClass: "contents" }, [
                _c(
                  "div",
                  {
                    class: _vm.show == 1 ? "hover" : "",
                    on: {
                      mouseleave: function($event) {
                        _vm.show = ""
                      },
                      mouseover: function($event) {
                        _vm.show = 1
                      }
                    }
                  },
                  [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.show != 1,
                          expression: "show != 1"
                        }
                      ],
                      attrs: {
                        src: require("../../assets/images/shopIntr/issue/ruzhu@2x.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.show == 1,
                          expression: "show == 1"
                        }
                      ],
                      attrs: {
                        src: require("../../assets/images/shopIntr/issue/ruzhuHeight@2x.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("p", [_vm._v("招商入驻")])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: _vm.show == 2 ? "hover" : "",
                    on: {
                      mouseleave: function($event) {
                        _vm.show = ""
                      },
                      mouseover: function($event) {
                        _vm.show = 2
                      }
                    }
                  },
                  [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.show != 2,
                          expression: "show != 2"
                        }
                      ],
                      attrs: {
                        src: require("../../assets/images/shopIntr/issue/zhuangxiu@2x.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.show == 2,
                          expression: "show == 2"
                        }
                      ],
                      attrs: {
                        src: require("../../assets/images/shopIntr/issue/dianpuHeight@2x.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("p", [_vm._v("店铺装修")])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: _vm.show == 3 ? "hover" : "",
                    on: {
                      mouseleave: function($event) {
                        _vm.show = ""
                      },
                      mouseover: function($event) {
                        _vm.show = 3
                      }
                    }
                  },
                  [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.show != 3,
                          expression: "show != 3"
                        }
                      ],
                      attrs: {
                        src: require("../../assets/images/shopIntr/issue/weifa@2x.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.show == 3,
                          expression: "show == 3"
                        }
                      ],
                      attrs: {
                        src: require("../../assets/images/shopIntr/issue/weifaHeight@2x.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("p", [_vm._v("违法处罚")])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: _vm.show == 4 ? "hover" : "",
                    on: {
                      mouseleave: function($event) {
                        _vm.show = ""
                      },
                      mouseover: function($event) {
                        _vm.show = 4
                      }
                    }
                  },
                  [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.show != 4,
                          expression: "show != 4"
                        }
                      ],
                      attrs: {
                        src: require("../../assets/images/shopIntr/issue/huodong@2x.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.show == 4,
                          expression: "show == 4"
                        }
                      ],
                      staticStyle: { "margin-left": "-1px" },
                      attrs: {
                        src: require("../../assets/images/shopIntr/issue/huodongHeight@2x.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("p", [_vm._v("营销活动")])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "boxHover" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.show == 1,
                        expression: "show == 1"
                      }
                    ],
                    on: {
                      mouseleave: function($event) {
                        _vm.show = ""
                      },
                      mouseover: function($event) {
                        _vm.show = 1
                      }
                    }
                  },
                  [_vm._m(7)]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.show == 2,
                        expression: "show == 2"
                      }
                    ],
                    on: {
                      mouseleave: function($event) {
                        _vm.show = ""
                      },
                      mouseover: function($event) {
                        _vm.show = 2
                      }
                    }
                  },
                  [_vm._m(8)]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.show == 3,
                        expression: "show == 3"
                      }
                    ],
                    on: {
                      mouseleave: function($event) {
                        _vm.show = ""
                      },
                      mouseover: function($event) {
                        _vm.show = 3
                      }
                    }
                  },
                  [_vm._m(9)]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.show == 4,
                        expression: "show == 4"
                      }
                    ],
                    on: {
                      mouseleave: function($event) {
                        _vm.show = ""
                      },
                      mouseover: function($event) {
                        _vm.show = 4
                      }
                    }
                  },
                  [_vm._m(10)]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "notice" }, [
              _vm._m(11),
              _vm._v(" "),
              _c("div", { staticClass: "box" }, [
                _c("div", [
                  _c("div", [
                    _c("img", { attrs: { src: _vm.imagesUrl, alt: "" } })
                  ]),
                  _vm._v(" "),
                  _vm._m(12)
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("div", [
                    _c("img", { attrs: { src: _vm.imagesUrl, alt: "" } })
                  ]),
                  _vm._v(" "),
                  _vm._m(13)
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("div", [
                    _c("img", { attrs: { src: _vm.imagesUrl, alt: "" } })
                  ]),
                  _vm._v(" "),
                  _vm._m(14)
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("div", [
                    _c("img", { attrs: { src: _vm.imagesUrl, alt: "" } })
                  ]),
                  _vm._v(" "),
                  _vm._m(15)
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "more" }, [_vm._v("更多公告")])
            ])
          ]),
      _vm._v(" "),
      _c("Footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo" }, [
      _c("img", {
        attrs: { src: require("../../assets/images/ruzhuLogo.png"), alt: "" }
      }),
      _vm._v(" "),
      _c("span", [_vm._v("招商")]),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src: require("../../assets/images/shopIntr/shop/huo@2x.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        staticStyle: { width: "80px", "margin-top": "45px" },
        attrs: { src: require("../../assets/images/ruzhuJiantou.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "iconText" }, [
      _c("div", [
        _c("img", {
          attrs: {
            src: require("../../assets/images/shopIntr/shop/menkan@2x.png"),
            alt: ""
          }
        }),
        _vm._v(" "),
        _c("p", [_vm._v("门槛低")]),
        _vm._v(" "),
        _c("p", [_vm._v("线上申请流程快")])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("img", {
          attrs: {
            src: require("../../assets/images/shopIntr/shop/kaidian@2x.png"),
            alt: ""
          }
        }),
        _vm._v(" "),
        _c("p", [_vm._v("一键开店")]),
        _vm._v(" "),
        _c("p", [_vm._v("省钱省心省力")])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("img", {
          attrs: {
            src: require("../../assets/images/shopIntr/shop/zhouqi@2x.png"),
            alt: ""
          }
        }),
        _vm._v(" "),
        _c("p", [_vm._v("结算周期短")]),
        _vm._v(" "),
        _c("p", [_vm._v("资金直接进入商家账户")])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("img", {
          attrs: {
            src: require("../../assets/images/shopIntr/shop/jinrong@2x.png"),
            alt: ""
          }
        }),
        _vm._v(" "),
        _c("p", [_vm._v("金融赋能")]),
        _vm._v(" "),
        _c("p", [_vm._v("信用变财富生意更轻松")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flow" }, [
      _c("div", { staticClass: "title" }, [
        _c("img", {
          attrs: {
            src: require("../../assets/images/shopIntr/shop/liuchen@2x.png"),
            alt: ""
          }
        })
      ]),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src: require("../../assets/images/shopIntr/shop/liucheng@2x.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card" }, [
      _c("div", [
        _c("img", {
          attrs: {
            src: require("../../assets/images/shopIntr/shop/quanyi@2x.png"),
            alt: ""
          }
        })
      ]),
      _vm._v(" "),
      _c("div", [
        _c("img", {
          attrs: {
            src: require("../../assets/images/shopIntr/shop/banner1@2x.png"),
            alt: ""
          }
        }),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("../../assets/images/shopIntr/shop/banner2@2x.png"),
            alt: ""
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "iconText2" }, [
      _c("div", [
        _c("img", {
          attrs: {
            src: require("../../assets/images/shopIntr/issue/bangzhu@2x.png"),
            alt: ""
          }
        }),
        _vm._v(" "),
        _c("p", [_vm._v("帮助中心")]),
        _vm._v(" "),
        _c("p", [_vm._v("自助进行问题学习解决")])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("img", {
          attrs: {
            src: require("../../assets/images/shopIntr/issue/kefu@2x.png"),
            alt: ""
          }
        }),
        _vm._v(" "),
        _c("p", [_vm._v("智能客服")]),
        _vm._v(" "),
        _c("p", [_vm._v("商家端智能服务助手")])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("img", {
          attrs: {
            src: require("../../assets/images/shopIntr/issue/peixun@2x.png"),
            alt: ""
          }
        }),
        _vm._v(" "),
        _c("p", [_vm._v("培训中心")]),
        _vm._v(" "),
        _c("p", [_vm._v("即时在线学习热门课程")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("img", {
        attrs: {
          src: require("../../assets/images/shopIntr/issue/remen@2x.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [_vm._v("小黄牛招商类目一览表")]),
      _vm._v(" "),
      _c("li", [_vm._v("招商联系方式")]),
      _vm._v(" "),
      _c("li", [_vm._v("店铺名称命名规格")]),
      _vm._v(" "),
      _c("li", [_vm._v("为什么商家对公账户认证要转钱")]),
      _vm._v(" "),
      _c("li", [_vm._v("小黄牛2021收费一览表")]),
      _vm._v(" "),
      _c("li", [_vm._v("运营联系方式")]),
      _vm._v(" "),
      _c("li", [_vm._v("入住流程1")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [_vm._v("小黄牛招商类目一览表")]),
      _vm._v(" "),
      _c("li", [_vm._v("招商联系方式")]),
      _vm._v(" "),
      _c("li", [_vm._v("店铺名称命名规格")]),
      _vm._v(" "),
      _c("li", [_vm._v("为什么商家对公账户认证要转钱")]),
      _vm._v(" "),
      _c("li", [_vm._v("小黄牛2021收费一览表")]),
      _vm._v(" "),
      _c("li", [_vm._v("运营联系方式")]),
      _vm._v(" "),
      _c("li", [_vm._v("入住流程1")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [_vm._v("小黄牛招商类目一览表")]),
      _vm._v(" "),
      _c("li", [_vm._v("招商联系方式")]),
      _vm._v(" "),
      _c("li", [_vm._v("店铺名称命名规格")]),
      _vm._v(" "),
      _c("li", [_vm._v("为什么商家对公账户认证要转钱")]),
      _vm._v(" "),
      _c("li", [_vm._v("小黄牛2021收费一览表")]),
      _vm._v(" "),
      _c("li", [_vm._v("运营联系方式")]),
      _vm._v(" "),
      _c("li", [_vm._v("入住流程1")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [_vm._v("小黄牛招商类目一览表")]),
      _vm._v(" "),
      _c("li", [_vm._v("招商联系方式")]),
      _vm._v(" "),
      _c("li", [_vm._v("店铺名称命名规格")]),
      _vm._v(" "),
      _c("li", [_vm._v("为什么商家对公账户认证要转钱")]),
      _vm._v(" "),
      _c("li", [_vm._v("小黄牛2021收费一览表")]),
      _vm._v(" "),
      _c("li", [_vm._v("运营联系方式")]),
      _vm._v(" "),
      _c("li", [_vm._v("入住流程1")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        attrs: {
          src: require("../../assets/images/shopIntr/issue/gonggao@2x.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text" }, [
      _c("p", [_vm._v("“国家营养餐试点”的食品安全如何守护？")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n              2011年，中央决定从秋季学期起，启动农2011年，中央决定从秋季学期起，启动农2011年，中央决定从秋季学期起，启动农\n            "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text" }, [
      _c("p", [_vm._v("“国家营养餐试点”的食品安全如何守护？")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n              2011年，中央决定从秋季学期起，启动农2011年，中央决定从秋季学期起，启动农2011年，中央决定从秋季学期起，启动农\n            "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text" }, [
      _c("p", [_vm._v("“国家营养餐试点”的食品安全如何守护？")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n              2011年，中央决定从秋季学期起，启动农2011年，中央决定从秋季学期起，启动农2011年，中央决定从秋季学期起，启动农\n            "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text" }, [
      _c("p", [_vm._v("“国家营养餐试点”的食品安全如何守护？")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n              2011年，中央决定从秋季学期起，启动农2011年，中央决定从秋季学期起，启动农2011年，中央决定从秋季学期起，启动农\n            "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-5379887d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-5379887d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/into/index.vue
// module id = null
// module chunks = 